import {
  CreateManualAllocationDto,
  CreateYardReservationDto,
  YardPositionDto,
} from '@storage/app/api'
import {
  ContainerTurnoverFilterFormMapper,
  ContainerTurnoversFilterFormProfile,
} from '../container-turnovers-filter-form'
import { ManualPlanningFormProfile } from './manual-reservation-form.profile'

export const getYardPosition = (manualPosition: string): YardPositionDto => {
  const parts = manualPosition.split('.')
  const [block, bay, row] = parts

  return {
    block,
    bay,
    row,
  }
}

const mapFormValuesToReservationDto = (
  containerTurnoverId: string,
  blockName: string,
  bayName: string,
  rowName: string,
  tierString: string,
  forceCreation = false,
): CreateYardReservationDto => {
  const tier = parseInt(tierString, 10)

  return {
    containerTurnoverId,
    yardPosition: {
      block: blockName,
      bay: bayName,
      row: rowName,
      tier,
    },
    forceCreation,
  }
}

const mapFormValuesToSingleContainerAllocationDto = (
  containerTurnoverId: string,
  { manualPosition }: ManualPlanningFormProfile,
  forceCreation = false,
): CreateManualAllocationDto => {
  return {
    containerTurnoverId: containerTurnoverId,
    yardPosition: getYardPosition(manualPosition),
    forceCreation,
  }
}

const mapFormValuesToAllocationDto = (
  filterFormProfile: ContainerTurnoversFilterFormProfile,
  { manualPosition }: ManualPlanningFormProfile,
  forceCreation = false,
): CreateManualAllocationDto => {
  return {
    filter: ContainerTurnoverFilterFormMapper.mapFormValuesToFilterDto(filterFormProfile, true),
    yardPosition: getYardPosition(manualPosition),
    forceCreation,
  }
}

export const ManualReservationFormMapper = {
  mapFormValuesToReservationDto,
  mapFormValuesToAllocationDto,
  mapFormValuesToSingleContainerAllocationDto,
}
